import { render, staticRenderFns } from "./ListRequireWarrantyStock.vue?vue&type=template&id=2b819c05&"
import script from "./ListRequireWarrantyStock.vue?vue&type=script&lang=js&"
export * from "./ListRequireWarrantyStock.vue?vue&type=script&lang=js&"
import style0 from "./ListRequireWarrantyStock.vue?vue&type=style&index=0&id=2b819c05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports